import PropTypes from "prop-types";
import { FluentBadge } from "../../../../../../components/FluentUI/Fluent-Badge";
import { FluentTooltip } from "../../../../../../components/FluentUI/Fluent-Tooltip";
import "../../../../../tasks/scenes/telerik-tasks/common-components/status-new.scss";

const statusMap = {
    "Not Started": "not-started",
    "In Progress": "in-progress",
    Declined: "in-progress",
    Submitted: "submitted",
    "Awaiting Approval": "awaiting-approval",
    "Pending Review": "awaiting-approval",
    "Assigned - Pending review": "awaiting-approval",
    "Pending Approval": "awaiting-approval",
    Inactive: "inactive",
    Completed: "completed",
    Closed: "completed",
    Approved: "completed",
    Cancelled: "cancelled",
    Archived: "not-started",
    Active: "active",
    Overdue: "cancelled",
    "Approved for Filing": "approved-for-filing",
    "Approved for Not Filing": "approved-for-not-filing",
  };

  const normalizeStatusColor = (raw) => {
    if (!raw) return null;
    const background =
      raw.backgroundColor ?? raw.BackgroundColor ?? null;
    const color =
      raw.fontColor ?? raw.FontColor ?? null;
    const borderColor =
      raw.borderColor ?? raw.BorderColor ?? null;

    if (!background && !color && !borderColor) return null;

    const style = {};
    if (background) style.background = background;
    if (color) style.color = color;
    if (borderColor) style.borderColor = borderColor;
    return style;
  };

  const StatusBadge = ({ status }) => {
    const trimStatus = (s) => {
      if (!s) return "";
      return s.length > 18 ? s.substring(0, 18) + "..." : s;
    };

    const statusName = status?.Name || "";
    const className = statusMap[statusName] || "";
    const overrideStyle = status?.BadgeColor ? normalizeStatusColor(status.BadgeColor) : "";

    return (
      <FluentTooltip
        target={
          <div className={(className ? className + " " : "") + "no-pointer width-fit-content"}>
            <FluentBadge
              shape="rounded"
              appearance="tint"
              size="extra-large"
              text={trimStatus(statusName)}
              style={overrideStyle || undefined}
              data-color-overridden={!!overrideStyle}
            />
          </div>
        }
        text={status?.Name || ""}
      />
    );
  };

  StatusBadge.propTypes = {
    status: PropTypes.oneOfType([
      PropTypes.shape({
        Name: PropTypes.string,
        BadgeColor: PropTypes.oneOfType([
          PropTypes.shape({
            BackgroundColor: PropTypes.string,
            FontColor: PropTypes.string,
            BorderColor: PropTypes.string,
          }),
          PropTypes.shape({
            backgroundColor: PropTypes.string,
            fontColor: PropTypes.string,
            borderColor: PropTypes.string,
          }),
        ]),
      }),
      PropTypes.shape({
        name: PropTypes.string,
        badgeColor: PropTypes.oneOfType([
          PropTypes.shape({
            BackgroundColor: PropTypes.string,
            FontColor: PropTypes.string,
            BorderColor: PropTypes.string,
          }),
          PropTypes.shape({
            backgroundColor: PropTypes.string,
            fontColor: PropTypes.string,
            borderColor: PropTypes.string,
          }),
        ]),
      }),
      PropTypes.oneOf([null, undefined]),
    ]),
  };

  StatusBadge.defaultProps = {
    status: null,
  };

  export default StatusBadge;
